// extracted by css-extract-rspack-plugin
var _1 = "MwMMfp1jiWIhdvZ5";
var _2 = "LDORahsAthwX22rM";
var _3 = "C611SeFprSYdTLU5";
var _4 = "WiUT7ks9okshbK2j";
var _5 = "toMGX_hOhTIHc_BS";
export { _1 as "button", _2 as "cb", _3 as "disabled", _4 as "grid", _5 as "identifier" }
